// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-module-found{display:flex;flex-direction:row;overflow:hidden;background-color:var(--background)}.no-module-found__message-wrapper{flex:1;display:flex;justify-content:center;flex-direction:column;align-items:center;height:100vh}.no-module-found__message-title{font-size:20px;font-weight:500;line-height:24px;text-align:center;color:var(--text);margin:8px 0}.no-module-found__message{font-size:16px;font-weight:400;color:var(--text--l2);text-align:center;padding:0 16px}", ""]);
// Exports
module.exports = exports;
